import { render } from "./openTickets.vue?vue&type=template&id=0c6a322c&scoped=true"
import script from "./openTickets.vue?vue&type=script&lang=js"
export * from "./openTickets.vue?vue&type=script&lang=js"

import "./openTickets.vue?vue&type=style&index=0&id=0c6a322c&scoped=true&lang=scss"
import "./openTickets.vue?vue&type=style&index=1&id=0c6a322c&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c6a322c"]])

export default __exports__